<template>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <DataTableWithCustomMixinSalaryCond :key="personal.pk" :initialFilter="{ tipo_de_condicion: 2 }" :headers="headers" :path="path" :filterPath="filterPath" filter
    actionButtonsName="ConditionsListActionButtons" :properties="properties" disableStore>
    </DataTableWithCustomMixinSalaryCond>
  </div>
</template>

<script>
import DataTableWithCustomMixinSalaryCond from '../../../common/ui/DataTableWithCustomMixinSalaryCond.vue'

export default {
  props: {
    personal: Object
  },
  data () {
    return {
      filterPath: `filter/personal/condiciones/${this.personal.pk}/${this.personal.club.pk}`
    }
  },
  components: {
    DataTableWithCustomMixinSalaryCond
  },
  computed: {
    path () {
      return `condiciones/player/${this.personal.pk}/${this.personal.club.pk}`
    },
    loading () {
      return !this.personal.hasOwnProperty('pk')
    },
    headers () {
      return [
        { text: 'Estado', value: 'estado', align: 'left', filterField: true },
        { text: 'ID', value: 'id_contrato', align: 'left' },
        { text: 'Temporada', value: 'temporada', align: 'left' },
        { text: 'Fecha Inicio', value: 'fecha_inicio', align: 'left' },
        { text: 'Fecha Fin', value: 'fecha_fin', align: 'left' },
        { text: 'Concepto', value: 'conceptoDisplay' },
        { text: 'Tipo de condición', value: 'tipo_de_condicion', filterField: true },
        { text: 'Bruto/Neto', value: 'tipoImporte' },
        { text: 'Frecuencia', value: 'frecuenciaDisplay' },
        { text: 'Importe', value: 'importe' },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
    },
    properties () {
      return ['estadoDisplay', 'idContrato', 'temporadaDisplay', 'fechaInicio', 'fechaFin', 'conceptoDisplay',
        'tipoDeCondicionDisplay', 'tipoImporteDisplay', 'frecuenciaDisplay', 'importeDisplay']
    }
  }
}
</script>
